import BackingDoc from './BackingDoc';

export default BackingDoc;
